import { branch, renderComponent } from 'recompose';
import Loader from '../components/Loader';

export default branch(
  ({ loading }) => loading,
  renderComponent(Loader),
);
